import type { EditorSDK } from '@wix/wix-data-client-common-standalone'

const getSdkVersionInPanel = async (
  editorSdkProxy: EditorSDK,
): Promise<string> => {
  const appApi = await editorSdkProxy.editor.getAppAPI()
  return appApi.getSdkVersion()
}

const getSdkVersionInWorker = (editorSdkProxy: EditorSDK): string =>
  editorSdkProxy.document.info.getSdkVersion().version

export const getSdkVersion = async (
  editorSdkProxy: EditorSDK,
): Promise<string | undefined> => {
  try {
    return await getSdkVersionInWorker(editorSdkProxy)
  } catch {
    try {
      return await getSdkVersionInPanel(editorSdkProxy)
    } catch {
      return undefined
    }
  }
}
